import styles from './PaceLegend.module.css'

/** `complete`: the period is over — no projection to show. */
export function PaceLegend({ hint, complete = false }: { hint?: string; complete?: boolean }) {
  return (
    <div className={styles.legend}>
      <span className={styles.item}>
        <span className={`${styles.swatch} ${styles.actual}`} />
        Cumulative actual
      </span>
      <span className={styles.item}>
        <span className={`${styles.swatch} ${styles.pace}`} />
        Even budget pace
      </span>
      {complete ? null : (
        <span className={styles.item}>
          <span className={`${styles.swatch} ${styles.projected}`} />
          Projected
        </span>
      )}
      {hint ? <span className={styles.hint}>{hint}</span> : null}
    </div>
  )
}
